import React from 'react';
import { Formik, Form } from 'formik';
import Input from '../../input'
import Modal from '../../modals/Modal'
import ButtonContained from '../../button';
import { AddBrandSchema } from '../../../validation/ValidationSchema';
import { toast } from "react-toastify";
import { api } from '../../../api';

const AddBrand = (props) => {
  
    const { showAddBrandModal, setShowAddBrandModal, closeModal,token,setListingReset } = props
    return (
        <Modal
        id="add_brand"
        showModal={showAddBrandModal}
        closeModal={closeModal}
        modalHeader="Add Brand"
        buttonText="SAVE">
        <Formik
            validationSchema={AddBrandSchema}
            initialValues={{
                BrandName: '',
                CompanyName: '',
                website: '',
                brandApiAccess: false
            }}
            onSubmit={(values, {resetForm}) => {
                const formBody = {
                    brandName: values.BrandName,
                    brandCompanyName: values.CompanyName,
                    brandWebsite: values.website,
                    brandApiAccess: values.brandApiAccess
                }

                api.brands.create(formBody,token).then(res => {
                    if (res.code === 200) {
                        resetForm()
                        toast.success("Brand added successfully!");
                        setShowAddBrandModal(false)
                        setListingReset(prev => !prev);
                        
                    } else {
                        toast.error(res.message);
                       
                        resetForm()
                    }
                }).catch(err => {
                    toast.error("Something went wrong!");
                    resetForm()

                })
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                isSubmitting,
                setFieldValue

            }) => {

                return (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="box-row">
                                    <div className="table-head ">
                                        {/* <h1 className="sec-header row align-items-center">ADD Brands</h1> */}
                                    </div>
                                    <div className="card" style={{margin: '0px'}}>
                                        {/* <div className="card-header card-header-title"> ADD BRAND */}
                                        {/* </div> */}
                                        <div className="card-body gatepass-saveoutput">
                                            <div className="reports">
                                                <Form onSubmit={handleSubmit}>
                                                    <div className="form-row">
                                                    <label style={{top: '26px'}}  className="col-sm-3 col-form-label"><b>Brand Name {' '}: </b></label>
                                                        <div className="form-group col-md-7">
                                                                <Input
                                                                    id="BrandName"
                                                                    name="BrandName"
                                                                    placeholder="Brand Name"
                                                                    type="text"
                                                                    value={values.BrandName}
                                                                    onChange={handleChange}
                                                                    error={touched.BrandName && errors.BrandName}
                                                                    errorText={errors.BrandName}
                                                                    disabled={isSubmitting} />
                                                        </div>
                                                    </div>  
                                                    <div className="form-row">  
                                                    <label style={{top: '26px'}} className="col-sm-3 col-form-label"><b>Company Name {' '}: </b></label>
                                                        <div className="form-group col-md-7">
                                                            <Input
                                                                id="CompanyName"
                                                                name="CompanyName"
                                                                placeholder="Company Name"
                                                                type="text"
                                                                value={values.CompanyName}
                                                                onChange={handleChange}
                                                                error={touched.CompanyName && errors.CompanyName}
                                                                errorText={errors.CompanyName}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>  
                                                    <div className="form-row">  
                                                    <label style={{top: '26px'}} className="col-sm-3 col-form-label"><b>Website {' '}: </b></label>
                                                        <div className="form-group col-md-7">
                                                            <Input
                                                                id="website"
                                                                name="website"
                                                                placeholder="Website"
                                                                value={values.website}
                                                                onChange={handleChange}
                                                                error={touched.website && errors.website}
                                                                errorText={errors.website}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        <div className="form-group col-sm-12 mt-2" style={{display: 'flex',  justifyContent: 'center'}}>
                                                            <span className="custom-control custom-checkbox">
                                                                <input
                                                                    disabled={isSubmitting}
                                                                    style={{ zIndex: '100' }}
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="customCheck"
                                                                    name="brandApiAccess"
                                                                    value={values.brandApiAccess}
                                                                    onChange={(e) => { setFieldValue('brandApiAccess', e.currentTarget.checked) }}>
                                                                </input>
                                                                <label className="custom-control-label" htmlFor="customCheck"> <b> API Access </b></label>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                    <div className="col text-center">
                                                    <ButtonContained buttonName="Save"
                                                        disabled={isSubmitting} />
                                                        </div>
                                                        </div>
                                                </Form>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Formik>
        </Modal>
    )
}
export default AddBrand